import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'system-settings',
    templateUrl: './system-settings.component.html',
    standalone: false
})
export class SystemSettings {

    constructor(private notificationService: NotificationService, private router: Router) {
    }

    public isLinkActive(name: string): boolean {
        if (name == "/system-settings") {
            return (this.router.url == name);
        }
        else {
            return (this.router.url == name || this.router.url.startsWith(name));
        }
    }
}
